<template>
  <ancestryline-modal title="modal.confirmation.title"  id="confirmation-modal" :close="true" @close="close" :loading="false">

    <div class="modal-body p-grid p-col-12 align-center">
      <div class="p-col-12 align-center">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 1.3rem;color: orange;"/><span style="font-size: 1.3rem;">{{$t('modal.confirmation.message')}}</span>
      </div>
    </div>

    <div class="p-col-12">
      <Button class="float-left p-button-outlined p-button-secondary p-mr-2" @click="close(false)">{{$t('btn.cancel')}}</Button>
      <Button class="p-mr-2 p-button p-component float-right" @click="close(true)" style="float: right;">
            <span class="p-button-label">
              <i class="pi pi-check p-mr-2"></i>{{$t('btn.confirm')}}
            </span>
      </Button>
    </div>
  </ancestryline-modal>
</template>

<script>
import DialogService from "@/business/ModalBusiness";

export default {

  name: "PublicAncestrylineConfirmation",

  methods:{

    close(confirm){
      DialogService.closeModal(confirm);
    }
  }
}
</script>

<style scoped>

.align-center {
  align-items: center;
  text-align: center;
}

.modal-body {
  min-height: 150px !important;
}

</style>